import "./Modal.scss";

import {FmlxDatePicker, FmlxModal} from 'fmlx-common-ui';
import {FMLX_BUTTON} from '../../../const/FmlxComponentEnum';
import {useDispatch, useSelector} from 'react-redux';
import {saveAssignEvent} from '../../../stores/business/teamAssignmentBusiness';
import {setShowModalDatePicker} from '../../../stores/actions/teamAssignmentAction';
import {useEffect, useState} from 'react';


const ModalJoinDate = () => {
  const dispatch = useDispatch();
  const showModalDatePicker = useSelector(state => state.teamAssignmentState.showModalDatePicker);
  const [date, setDate] = useState(new Date());
  const [dateString, setDateString] = useState('');

  useEffect(() => {
    if (date) {
      setDateString(date.toISOString().split('T')[0]);
    }
  }, [date]);

  if (!showModalDatePicker) {
    return null;
  }

  return (
    <FmlxModal
      open={showModalDatePicker}
      size="md"
      title="Please Input Join Date Of New Member"
      onCloseClick={() => dispatch(setShowModalDatePicker(false))}
      primaryButton={{
        show: true,
        disabled: false,
        label: 'Save',
        type: FMLX_BUTTON.TYPE.PRIMARY,
        variant: FMLX_BUTTON.VARIANT.CONTAIN,
        onClick: () => dispatch(saveAssignEvent(date))
      }}
      secondaryButton={{
        show: true,
        disabled: false,
        label: 'Cancel',
        type: FMLX_BUTTON.TYPE.BASIC,
        variant: FMLX_BUTTON.VARIANT.CONTAIN,
        onClick: () => dispatch(setShowModalDatePicker(false))
      }}
      tertiaryButton={{
        show: false
      }}
    >
      <div className="dropdown-modal-joindate">
        <FmlxDatePicker
          variant='date'
          value={dateString}
          onChange={(event, newDate) => {
            if (newDate) {
              setDate(new Date(newDate));
            }
          }}
        />
      </div>
    </FmlxModal>
  );
};

export default ModalJoinDate;